import StateModel from "Cart/store/models/stateModel";

const getters = {
	/** @param {StateModel} state */
	totalSum: state => {
		let result = state.products.reduce(function (totalSum, product) {
			let price = product.price.replace(",", ".") * product.count;
			return totalSum + price;
		}, 0);
		return result.toFixed(2);
	},
	itemCount: state => {
		return state.products.length;
	},
	cartProducts: state => {
		return state.products;
	},
	cartComment: state => {
		return state.comment;
	},
	checkedItemCount: state => {
		let checkedItems = state.products.filter(product => product.checked === true);
		return checkedItems.length;
	}
};
export { getters };